import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CloseIcon from "../../assets/vizr_images/ic_remove.svg";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import UploadForm from "./MultiFileUpload";
import IncidentDetails from "./IncidentDetails";
import IncidentComments from "./IncidentComments";
import IncidentDueDate from "./IncidentDueDate";
import "./IncidentSidebar.scss";

import {
  FETCH_INCIDENT_JIRA_DATA,
  UPLOAD_FILES_COMMENT_REQUEST,
  DEFAULT_RESOLUTION,
  UPLOAD_FILES_CHANGE_STATUS,
} from '../../redux/constants/constants';
import JiraIncidentDetails from "../MDRDashboard/JiraIncidentDetails";
import store from "../../redux/store/store";

const IncidentSidebar = ({ incidentData, diff, loc }) => {
  const dispatch = useDispatch();
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [newStatus, setNewStatus] = useState({});
  const jiraData = useSelector((state) => state.IncidentSidebarReducer.jiraData);
  const dataLoader = useSelector((state) => state.IncidentSidebarReducer.incLoader);
  const isIncidentDrawerPopupOpen = useSelector((state) => state.IncidentSidebarReducer.isIncidentDrawerPopupOpen);
  const actionSucess = useSelector((state) => state.IncidentSidebarReducer.actionSucess);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState('error');
  const [newResolution, setNewResolution] = useState({ name: DEFAULT_RESOLUTION });

  useEffect(() => {
    if (actionSucess === true) {
      setSnackbarSeverity('success');
      setSnackBarMessage("Action completed successfully!");
      setSnackbarOpen(true);
    } else if (actionSucess === false) {
      setSnackbarSeverity('error');
      setSnackBarMessage("Action failed. Please try again.");
      setSnackbarOpen(true);
    }
  }, [actionSucess]);

  const handleSnakbarClose = () => {
    setSnackBarMessage('');
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (isIncidentDrawerPopupOpen === false) {
      handleCloseDialog();
    }
  }, [isIncidentDrawerPopupOpen]);

  const transitions = jiraData?.transitions?.transitions || [];
  const status = jiraData?.details?.fields?.status;
  const resolution = jiraData?.issueResolutions?.fields?.resolution;
  const commentResponse = jiraData?.details?.fields?.comment;
  const dueDate = jiraData?.details?.fields?.duedate;
  const resolutions = jiraData?.resolutions || [];
  const permissions = store.getState().applicationData.permissions;
  useEffect(() => {
    if (transitions.length > 0) {
      setNewStatus({ ...transitions[0] });
    }
  }, [transitions]);

  useEffect(() => {
    if (resolutions && resolutions.length > 0) {
      setNewResolution(DEFAULT_RESOLUTION);
    }
  }, [resolutions]);

  useEffect(() => {
    if (incidentData["IncidentsTable.jiraTicketId"] || incidentData.ticketId) {
      dispatch({ type: FETCH_INCIDENT_JIRA_DATA, payload: loc === "Jira" ? incidentData.ticketId : incidentData["IncidentsTable.jiraTicketId"] });
    }
  }, []);

  const Alert = (props) => <MuiAlert elevation={6} variant="filled" {...props} />;

  const handleSubmit = (files, comment) => {
    if (openCommentDialog) {
      if (comment.trim()) {
        dispatch({
          type: UPLOAD_FILES_COMMENT_REQUEST,
          payload: { files, comment, ticketId: loc === "Jira" ? incidentData.ticketId : incidentData["IncidentsTable.jiraTicketId"] }
        });
      }
    } else if (openStatusDialog) {
      dispatch({
        type: UPLOAD_FILES_CHANGE_STATUS,
        payload: {
          files,
          ticketId: loc === "Jira" ? incidentData.ticketId : incidentData["IncidentsTable.jiraTicketId"],
          comment: comment,
          transitionId: newStatus.id,
          jiraId: loc === "Jira" ? incidentData.ticketId : incidentData["IncidentsTable.jiraTicketId"],
          oldStatus: status.name,
          newStatus: newStatus.name,
          resolution: (newResolution === DEFAULT_RESOLUTION) ? null : newResolution,
        },
      });
    }
  };

  const handleCloseDialog = () => {
    setOpenCommentDialog(false);
    setOpenStatusDialog(false);
    setNewStatus({});
  };

  const renderCommentOrStatusAction = () => {
    if (openCommentDialog) return "Add Comment";
    if (openStatusDialog) return "Change Status";
  };

  const showResolution = () => {
    return (
      newStatus &&
      (newStatus?.name?.toLowerCase() === "mark as done" ||
        newStatus?.name?.toLowerCase() === "done") &&
      resolutions &&
      resolutions.length > 0
    );
  };

  const renderActions = () => (
    <div className="flex-container">
      {permissions?.includes("ADD_JIRA_COMMENT") && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenCommentDialog(true)}
        >
          Add Comment
        </Button>
      )}
      {permissions?.includes("UPDATE_JIRA_STATUS") && (
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setOpenStatusDialog(true)}
        >
          Change Status
        </Button>
      )}
      <div>
        <Dialog
          open={openCommentDialog || openStatusDialog}
          onClose={handleCloseDialog}
          aria-labelledby="add-comment-dialog-title"
          fullWidth
          maxWidth="md"
        >
          {dataLoader && (
            <img
              src={Page_Loader}
              alt="loading"
              className="loader-data-source tenantProfileLoader"
            />
          )}
          <div className="dlg-action-container">
            <Button
              onClick={handleCloseDialog}
              aria-label="close"
              className="inc-popup-close-btn"
            >
              <img src={CloseIcon} alt={"close"} />
            </Button>
            <div className="dlg-title mrg-btm-16">
              {renderCommentOrStatusAction()}
            </div>
            {openStatusDialog && (
              <div className="status-drp-container">
                <div className="mrg-btm-16">
                  Change Status from <b>{status.name}</b> to{" "}
                  <select
                    className="status-drp-select"
                    value={newStatus.id || ""}
                    onChange={(e) => {
                      const selected = transitions.find(
                        (t) => t.id === e.target.value,
                      );
                      setNewStatus(selected || {});
                    }}
                  >
                    {transitions &&
                      transitions.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                  </select>
                  {showResolution() && resolutions.length > 0 && (
                    <>
                      <span> Resolution: </span>
                      <select
                        className="status-drp-select"
                        value={newResolution || DEFAULT_RESOLUTION}
                        onChange={(e) => setNewResolution(e.target.value)}
                      >
                        <option value="">Select Resolution</option>
                        {resolutions.map((res) => (
                          <option key={res.id} value={res.name}>
                            {res.name}
                          </option>
                        ))}
                      </select>
                    </>
                  )}
                </div>
              </div>
            )}
            <UploadForm handleSubmit={handleSubmit} />
            <div className="inc-comment-conatiner">
              <div className="inc-popup-comments-section">
                <div className="inc-popup-comments-title">Comments</div>
                <div className="comment-list">
                  <IncidentComments commentResponse={commentResponse} />
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnakbarClose}
      >
        <Alert onClose={handleSnakbarClose} severity={snackbarSeverity}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
      {dataLoader && (
        <img
          src={Page_Loader}
          alt="loading"
          className="loader-data-source tenantProfileLoader"
        />
      )}
      <div className="inc-popup-root">
        <div className="mdr-container">
          <div className="inc-popup-header">
            <div className="access_Details">Incident Details</div>
            <Button
              onClick={() => dispatch({ type: "CLOSE_INCIDENT_DRAWER" })}
              aria-label="close"
              className="inc-popup-close-btn"
            >
              <img src={CloseIcon} alt={"close"} />
            </Button>
          </div>
          <div className="inc-details-container">
            <div className="inc-popup-content">
              {loc === "Jira" ? (
                <JiraIncidentDetails incidentData={incidentData} diff={diff} />
              ) : (
                <IncidentDetails incidentData={incidentData} diff={diff} />
              )}
            </div>
          </div>
          {(loc === "Jira" && incidentData?.ticketId) ||
          (loc !== "Jira" && incidentData?.["IncidentsTable.jiraTicketId"]) ? (
            <>
              <div className="inc-comment-conatiner">
                <div className="inc-popup-comments-section">
                  <div className="inc-popup-comments-title">Comments</div>
                  <div className="comment-list">
                    <IncidentComments commentResponse={commentResponse} />
                  </div>
                </div>
              </div>
              <div className="inc-popup-duedate">
                <IncidentDueDate
                  dueDate={dueDate}
                  status={status}
                  resolution={resolution}
                />
              </div>
              <div className="action-container">
                <div className="inc-popup-comments-title">Actions</div>
                {renderActions()}
              </div>
            </>
          ) : (
            <span className="no-data">Jira ticket not found</span>
          )}
        </div>
      </div>
    </>
  );
};

export default IncidentSidebar;
